var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_458_29681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.132263 1.31087L1.49098 0.631265L15.7032 1.15701L15.4213 13.4642L13.0336 14.6475L0.0144043 13.8337L0.132263 1.31087Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_458_29681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.47957 1.95848L14.2296 4.33348V13.8335L9.47957 11.4585L5.52124 13.0418L0.77124 10.6668V1.16681L5.52124 3.54181L9.47957 1.95848Z",
    stroke: "black",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47937 11.4583V1.95831",
    stroke: "black",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52112 3.54163V13.0416",
    stroke: "black",
    strokeWidth: 0.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBlack);
export default __webpack_public_path__ + "static/media/map-black.b48ab0f1dbfdf915dbdbe27458a5d9ce.svg";
export { ForwardRef as ReactComponent };